<template>
  <div id="main" class="main">
   {{errmessage}}
  </div>
</template>

<script>
import config from "@/config";
export default {
  name: "main",
  urlData: {},
  data() {
      return {
          errcode:"",
          errmessage:"正在登录"
      };
  },
  methods: {},
  components: {},
  created() {
    var t = this;
      var query = t.$route.query;
      console.log("wxloginresult",query);
      if(query.errcode && query.errcode=="0")
      {
        var app_login_user = { sessionkey:query.sessionkey,userid:"",auth:1 };
        localStorage.setItem(config.login_key,JSON.stringify(app_login_user));
        var login_redirect = localStorage.getItem("login_redirect");
        console.log(" wxloginresult app_login_user ",localStorage.getItem(config.login_key))
        if(login_redirect) 
        {
            login_redirect = JSON.parse(login_redirect);
            if(login_redirect.query.clear) login_redirect.query.clear =0;
            //localStorage.removeItem("login_redirect");
            console.log("wxloginresult login_redirect",login_redirect)
            
            t.$router.push({
                path: login_redirect.path,
                query:login_redirect.query
            });
        }
        else {
            t.$router.push({
                path: "/"
            });
        }
       
      }
      else {
          t.errcode = query.errcode;
          switch(t.errcode)
          {
              case "3001":
                t.errmessage= "非法登录";
                break;
              case "3002":
                t.errmessage= "无效的code";
                break;
              case "3003":
                t.errmessage= "授权失败";
                break;
              default:
                t.errmessage= "登录失败";
                break;
          }
      }
      console.log(query);
  }
};
</script>
<style scoped lang="scss">
</style>